import React from 'react';
import Badge from '../Badge';
import { getStatusTone, getStatusLabel } from './status-map';
import '../Badge/badge.css';

/**
 * StatusBadge: renders a domain status consistently.
 * appearance="dot" (default, for tables): coloured dot + word.
 * appearance="pill": soft filled pill.
 * tone overrides the automatic mapping; label overrides the text.
 */
export default function StatusBadge({ status, label, tone, appearance = 'dot', className = '', ...rest }) {
    const t = tone || getStatusTone(status);
    const text = label ?? getStatusLabel(status);
    if (appearance === 'pill') {
        return <Badge variant={t} className={className} {...rest}>{text}</Badge>;
    }
    return <span className={`ds-status ds-status--${t} ${className}`} {...rest}>{text}</span>;
}
